// Versione "lite" (palette awrabet/koba) dell'event widget (carosello partite) per la home di gojjobet.
// Copia 1:1 del template awrabet (card arrotondata, bottoni a pillola, scrollbar awrabet) con i token
// rinominati: slate -> gojjo-lite, kobaaccent -> gojjo-gold-lite.
import { h, Fragment } from "preact";
import PFeed from "../../../services/prematch-feed";
import Ticket from "../../jamibet/utils/ticket-logic.jsx";
import formatOdd from "../../../services/odds-format";
import AutomatedSlider from "../../jamibet/utils/auto-slider";

import {
	WidgetEventsCarouselContent as AwrabetWidgetEventsCarouselContent,
	EventWidgetSlide as AwrabetEventWidgetSlide,
} from "../../awrabet/desktop-components/prematch-events-widget.jsx";

// --- template lite locali (1:1 awrabet, token rinominati) ---
function SliderStyled({ children }) {
	return <AutomatedSlider class="scrollbar-x-fancy-lite">{children}</AutomatedSlider>;
}
function ScrollContent({ children }) {
	return <div class="flex gap-3 font-roboto mb-1">{children}</div>;
}
function OddsContainer({ children }) {
	return <div class="fn-event-odds flex justify-between gap-1 py-2">{children}</div>;
}
function TeamIconXs({ src }) {
	return <img class="h-4" src={src} />;
}

// Bottone a pillola (awrabet prematch-single-event OutcomeButton)
function OutcomeButton({ onClick, selected, children }) {
	if (selected)
		return <div
			class="cl-pse-out-btn flex h-11 leading-none grow flex flex-col items-center justify-center rounded-3xl overflow-hidden border border-gojjo-gold-lite-400 text-gojjo-lite-950 bg-gojjo-gold-lite-400 cursor-pointer"
			onClick={onClick}>
			{children}
		</div>
	return <div
		class="cl-pse-out-btn flex h-11 leading-none grow flex flex-col items-center justify-center rounded-3xl overflow-hidden border border-gojjo-gold-lite-400 bg-gojjo-lite-100 hover:bg-gojjo-gold-lite-400 cursor-pointer"
		onClick={onClick}>
		{children}
	</div>
}
function OutcomeName({ children }) {
	return <span class="cl-pse-out-name h-4 px-4 min-w-0 max-w-full truncate text-sm text-gojjo-lite-950">{children}</span>
}
function OutcomeValue({ value, selected }) {
	return <span class="cl-pse-out-value h-4 text-gojjo-lite-950 text-sm">{!!value ? formatOdd(value) : '-'}</span>
}

function ExtendedOddButton({ market, outcome }) {
	return (
		<OutcomeButton
			selected={Ticket.hasPrematchOdds(outcome.id)}
			onClick={() => Ticket.togglePrematchOdds(outcome.id)}
		>
			<OutcomeName>{outcome.name}</OutcomeName>
			<OutcomeValue selected={Ticket.hasPrematchOdds(outcome.id)} value={outcome.value} />
		</OutcomeButton>
	);
}

export class WidgetEventsCarouselContent extends AwrabetWidgetEventsCarouselContent {
	render() {
		if (!this.state.events) return null;

		return (
			<SliderStyled>
				<ScrollContent>
					{Object.values(this.state.events)
						.filter((event) => event.date * 1e3 > Date.now())
						.map((event) => (
							<EventWidgetSlide event={event} />
						))}
				</ScrollContent>
			</SliderStyled>
		);
	}
}

export class EventWidgetSlide extends AwrabetEventWidgetSlide {
	render({ event }) {
		if (!PFeed.NStorage.get(event.category)) return null;

		const eventMarkets = Object.values(event.sub || {});
		if (!eventMarkets.length || !Object.values(eventMarkets[0].sub || {}).length) return null;

		return <div class="rounded-lg overflow-hidden font-bold w-80 shrink-0 text-sm bg-gojjo-lite-100 text-gojjo-lite-700 relative">
			<div class="absolute right-3 top-1 text-center">
				<div class="relative w-20 bg-gojjo-gold-lite-500 text-gojjo-lite-950 text-center py-0.5 text-xs -right-1/2 rotate-45">TOP</div>
			</div>
			<div class="fn-wg-top-row flex gap-2 px-2 pb-1 pt-1 text-sm">
				<div class="fn-tournament min-w-0 text-gojjo-gold-lite-600 truncate">{PFeed.NStorage.get(event.category).name} - {event.tournament_name}</div>
				<div class="fn-date">{this.formatEventTime(event)}</div>
			</div>
			<div class="fn-wg-match-name flex gap-1 items-center px-2 pb-0.5 text-base">
				<div class="min-w-0 flex gap-1 shrink w-1/2 justify-start items-center">
					<TeamIconXs src={this.formatHomeTeamIconUrl(event)} />
					<div class="truncate overflow-hidden min-w-0">{event.home}</div>
				</div>
				<div class="w-12 flex-0 text-center text-gojjo-lite-500">VS</div>
				<div class="min-w-0 flex gap-1 shrink w-1/2 justify-end items-center">
					<div class="truncate overflow-hidden min-w-0">{event.away}</div>
					<TeamIconXs src={this.formatAwayTeamIconUrl(event)} />
				</div>
			</div>
			<div class="px-2">
				<OddsContainer>
					{eventMarkets
						.slice(0, 1)
						.flatMap((market) => Object.values(market.sub).map((outcome) => [market, outcome]))
						.map(([market, outcome]) => (
							<ExtendedOddButton market={market} outcome={outcome} />
						))}
				</OddsContainer>
			</div>
		</div>
	}
}
